import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "81",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M52.6 32.734H.4v19.535h52.2V32.734Zm-3.2 3.199v13.135H3.6V35.933h45.8Z" }),
      _createElementVNode("path", { d: "M43.748.4H9.252L5.005 35.934h42.99L43.748.4Zm-2.84 3.2 3.481 29.134H8.61L12.091 3.6h28.817ZM47.792 50.669V80h-3.2V50.67zM8.408 50.669V80h-3.2V50.67z" })
    ], -1)
  ])))
}
export default { render: render }